const DOMAIN = 'GLOBAL';

const eventsList = {
  GLOBAL: {
    HIDE_NAVIGATION: 'HIDE_NAVIGATION',
    HIDE_TRACKING_NOTICE: 'HIDE_TRACKING_NOTICE',
    SHOW_TRACKING_NOTICE: 'SHOW_TRACKING_NOTICE',
  },
};

/**
 * Looks up the event from eventsList by passing in a string.
 * @param {string} theEvent
 * @returns {string}
 */
const events = (theEvent = '') => {
  const keys = theEvent.split('.');
  let domainStr = DOMAIN;
  let eventStr = '';
  if (keys.length > 1) {
    domainStr = keys[0];
    eventStr = keys[1];
  } else {
    eventStr = keys[0];
  }
  // console.log('event', { theEvent, domainStr, eventStr }); // eslint-disable-line no-console
  return eventsList[domainStr][eventStr];
};

export default events;
